import { useContext } from 'react';
import { NextPage } from 'next';

import { selectCmsPageSection } from 'utils/locale';

import LocaleContext from 'components/context/Locale';
import Head from 'components/layout/Head';
import PageContainer from 'components/layout/PageContainer';
import LayoutDefault from 'components/modules/public/layouts/Default';

import SectionArticle from './sections/Articles';
import SectionHero from './sections/Hero';
import SectionNewsletter from './sections/Newsletter';
import Search from './sections/Search';
import StyledComponent from './styles';
import { Props } from './types';

const PublicPageArticlesEmployeeList: NextPage<Props> = ({ articles, articleCategories, cmsPage }) => {
    const localeContext = useContext(LocaleContext);
    const data = localeContext?.translations?.articlesEmployeeList;

    return (
        <StyledComponent className="public-page-articlesemployee">
            <Head
                {...data.meta}
                title={cmsPage?.metaTitle || data?.meta?.title}
                description={cmsPage?.metaDescription || data?.meta?.description}
                robots={cmsPage?.metaRobots}
                image={cmsPage?.image?.imageUrl || data?.meta?.image}
            />
            <LayoutDefault>
                <PageContainer>
                    <SectionHero
                        translations={{
                            ...data.content.hero,
                            ...selectCmsPageSection(cmsPage, 'hero'),
                        }}
                    />
                    <Search
                        translations={{
                            ...data.content.form,
                            ...selectCmsPageSection(cmsPage, 'form'),
                        }}
                        articleCategories={articleCategories}
                    />
                    {Array.isArray(articles) && articles.length > 0 && articles
                        .map(article => (
                            <SectionArticle
                                key={article.category.id}
                                articleCategory={article.category}
                                articles={article.elements.elements}
                                translations={{
                                    ...data.content.sectionArticleProps,
                                    ...selectCmsPageSection(cmsPage, 'sectionarticleprops'),

                                }}
                            />
                        ))}
                    {/* <SectionTutorials
                        {...data.content.tutorials}
                        articles={tutorials}
                    /> */}
                    <SectionNewsletter
                        translations={{
                            ...data.content.newsletter,
                            ...selectCmsPageSection(cmsPage, 'newsletter'),
                        }}
                    />
                </PageContainer>
            </LayoutDefault>
        </StyledComponent>
    );
};

export default PublicPageArticlesEmployeeList;
